import { render, staticRenderFns } from "./AdminOrderForm.vue?vue&type=template&id=644f14fb&scoped=true&"
import script from "./AdminOrderForm.vue?vue&type=script&lang=js&"
export * from "./AdminOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f14fb",
  null
  
)

export default component.exports